/* Component Dependencies */
var fitnessOfferingsTemplate = require('templates/fitnessOfferings.hbs');
var fitnessOfferingsNearbyTemplate = require('templates/fitnessOfferings-nearby.hbs');
var AriesComponent = require('libs/aries-component');

AriesComponent.create({
  type: 'fitnessOfferings',
  template: {
    'fitnessOfferings': fitnessOfferingsTemplate,
    'fitnessOfferings-nearby': fitnessOfferingsNearbyTemplate
  }
});
